/**
 * ScanLine
 *
 * SCAN中だけ画面を上下に走る緑の光線。
 * 視覚的に「いま自動認識してるよ」を伝える演出。
 *
 * isScanning が false の間は何も描画しない（DOMから消す）。
 * これによりCSSアニメーション自体が走らずGPUを温存する。
 */

import styles from './ScanLine.module.css';

export interface ScanLineProps {
  active: boolean;
}

export function ScanLine({ active }: ScanLineProps) {
  if (!active) return null;
  return (
    <div className={styles.root} aria-hidden>
      <div className={styles.glow} />
      <div className={styles.line} />
    </div>
  );
}
